import { render, staticRenderFns } from "./App.vue?vue&type=template&id=aa45ebf8&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=aa45ebf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa45ebf8",
  null
  
)

export default component.exports